import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AppContextProvider from "./context/app/provider";
import AuthContextProvider from "./context/auth/provider";
import "./index.css";
import CategoryContextProvider from "./context/category/provider";
import TrackingContextProvider from "./context/tracking-map/provider";
import NotificationContextProvider from "./context/notification/provider";
import ProductContextProvider from "./context/product/provider";
import ChatContextProvider from "./context/chat/provider";
import { I18nextProvider } from "react-i18next";
import i18n from "./utils/localization/i18n";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <Ract.StrictMode>
  <BrowserRouter>
    <ProductContextProvider>
      <NotificationContextProvider>
        <CategoryContextProvider>
          <AuthContextProvider>
            <TrackingContextProvider>
              <AppContextProvider>
                <I18nextProvider i18n={i18n}>
                  <ChatContextProvider>
                  <App />
                  </ChatContextProvider>
                </I18nextProvider>
              </AppContextProvider>
            </TrackingContextProvider>
          </AuthContextProvider>
        </CategoryContextProvider>
      </NotificationContextProvider>
    </ProductContextProvider>
  </BrowserRouter>
  //  </Ract.StrictMode>
);
